import React, { Component } from 'react';
import Tibbit_base from '@appblocks/frontend/client/Components/TPP/Tibbit_base';

export default class Tibbit_connector_wide extends Tibbit_base {
    constructor(props: any) {
        super(props);
        this.width = 120.63;
        this.height = 54;
    }

    render() {
        switch (this.props.num.substring(1)) {
            case 'WA2000U':
            case 'WA2000C':
                return (
                    <g id="ga1000-sga-c" {...this.props} className="tibbit">
                        <rect className="wa2000color" x={0.5} y={0} width={53.92} height={119.101} />

                        <rect x="2.87" y="14.204" className="labelColor" width="48.18" height="76.235" />

                        <g transform="rotate(270)">
                            <text transform="translate(-85,15)" className="label" id="LBL_num">{this.props.num}</text>
                            <text transform="translate(-85,35)" className="desc">
                                {this.renderDescriptions()}
                            </text>
                        </g>
                    </g>
                );
            case 'WM6256':
                return (
                    <g id="ga1000-sga-c" {...this.props} className="tibbit">
                        <rect className="wa2000color" x={0.5} y={0} width={53.92} height={102.101} />

                        <rect x="2.87" y="14.204" className="labelColor" width="48.18" height="76.235" />

                        <g transform="rotate(270)">
                            <text transform="translate(-85,15)" className="label" id="LBL_num">{this.props.num}</text>
                            <text transform="translate(-85,35)" className="desc">
                                {this.renderDescriptions()}
                            </text>
                        </g>
                    </g>
                );
            default:
                return (
                    <g id="ga1000-sga-c" {...this.props} className="tibbit">
                        <polygon className="ga1000color" points="19.838,119.101 0,119.101 0,0 53.92,0 53.92,104.93 19.838,104.93 &#9;" />
                        <rect x="2.87" y="14.204" className="labelColor" width="48.18" height="76.235" />

                        <g transform="rotate(270)">
                            <text transform="translate(-85,15)" className="label" id="LBL_num">{this.props.num}</text>
                            <text transform="translate(-85,35)" className="desc">
                                {this.renderDescriptions()}
                            </text>
                        </g>
                        <polygon className="tibbitStroke" points="19.838,119.101 0,119.101 0,0 53.92,0 53.92,104.93 19.838,104.93 &#9;" />
                    </g>
                );
        }
    }
}
